import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-deep-blue border-t border-accent-blue/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="flex flex-col items-start">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://res.cloudinary.com/newaisystems/image/upload/f_auto,q_auto,w_40/v1746902475/logo_tab_bhgydm.png" 
                srcSet="https://res.cloudinary.com/newaisystems/image/upload/f_auto,q_auto,w_40/v1746902475/logo_tab_bhgydm.png 1x, https://res.cloudinary.com/newaisystems/image/upload/f_auto,q_auto,w_80/v1746902475/logo_tab_bhgydm.png 2x"
                alt="New AI Systems Logo" 
                className="w-10 h-10 object-contain"
                loading="lazy"
                decoding="async"
              />
              <span className="font-mono font-bold text-xl tracking-wide text-text-light">
                NEW AI SYSTEMS
              </span>
            </div>
            <p className="text-text-light/80 mb-6">
              Powering business growth through innovative AI automation solutions.
            </p>
            <p className="text-text-light/80 mb-2">
              I have more questions!
            </p>
            <Link
              to="/ask-question"
              className="btn-primary"
            >
              CLICK HERE
            </Link>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl mb-4">QUICK LINKS</h3>
            <div className="space-y-4 font-mono">
              <Link to="/" className="block text-text-light/80 hover:text-electric-blue transition-colors duration-300">
                HOME
              </Link>
              <Link to="/about" className="block text-text-light/80 hover:text-electric-blue transition-colors duration-300">
                ABOUT
              </Link>
              <Link to="/faqs" className="block text-text-light/80 hover:text-electric-blue transition-colors duration-300">
                FAQs
              </Link>
              <Link to="/contact" className="block text-text-light/80 hover:text-electric-blue transition-colors duration-300">
                CONTACT
              </Link>
              <Link to="/book" className="block text-text-light/80 hover:text-electric-blue transition-colors duration-300">
                BOOK
              </Link>
              <Link to="/terms-of-service" className="block text-text-light/80 hover:text-electric-blue transition-colors duration-300">
                TERMS OF SERVICE
              </Link>
              <Link to="/privacy-policy" className="block text-text-light/80 hover:text-electric-blue transition-colors duration-300">
                PRIVACY POLICY
              </Link>
            </div>
          </div>

          {/* Our Services */}
          <div>
            <h3 className="text-xl mb-4">OUR SERVICES</h3>
            <div className="space-y-4 font-mono">
              <Link to="/chatbot-development" className="block text-text-light/80 hover:text-electric-blue transition-colors duration-300">
                CHATBOT DEVELOPMENT
              </Link>
              <Link to="/automated-outreach" className="block text-text-light/80 hover:text-electric-blue transition-colors duration-300">
                AUTOMATED OUTREACH
              </Link>
              <Link to="/follow-up-system" className="block text-text-light/80 hover:text-electric-blue transition-colors duration-300">
                FOLLOW-UP SYSTEM
              </Link>
              <Link to="/website-optimization" className="block text-text-light/80 hover:text-electric-blue transition-colors duration-300">
                WEBSITE OPTIMIZATION
              </Link>
              <Link to="/app-development" className="block text-text-light/80 hover:text-electric-blue transition-colors duration-300">
                APP DEVELOPMENT
              </Link>
              <Link to="/custom-automation" className="block text-text-light/80 hover:text-electric-blue transition-colors duration-300">
                CUSTOM AUTOMATION
              </Link>
            </div>
          </div>
          {/* Contact Info */}
          <div>
            <h3 className="text-xl mb-4">CONTACT US</h3>
            <div className="space-y-4">
              <div>
                <p className="text-text-light/60 text-sm">Business Development</p>
                <a href="mailto:contact@newaisystems.com" className="text-text-light/80 hover:text-electric-blue transition-colors duration-300 flex items-center gap-2">
                  <Mail className="h-4 w-4" />
                  contact@newaisystems.com
                </a>
              </div>
              <div>
                <p className="text-text-light/60 text-sm">General Inquiries</p>
                <a href="mailto:info@newaisystems.com" className="text-text-light/80 hover:text-electric-blue transition-colors duration-300 flex items-center gap-2">
                  <Mail className="h-4 w-4" />
                  info@newaisystems.com
                </a>
              </div>
              <div>
                <p className="text-text-light/60 text-sm">Support</p>
                <a href="mailto:support@newaisystems.com" className="text-text-light/80 hover:text-electric-blue transition-colors duration-300 flex items-center gap-2">
                  <Mail className="h-4 w-4" />
                  support@newaisystems.com
                </a>
              </div>
              <div className="flex space-x-4 pt-4">
                <a 
                  href="https://www.instagram.com/newaisystems/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-text-light hover:text-electric-blue transition-colors duration-300"
                >
                  <Instagram className="h-5 w-5" />
                </a>
                <a href="https://x.com/newaisystems" target="_blank" rel="noopener noreferrer" className="text-text-light hover:text-electric-blue transition-colors duration-300">
                  <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
                  </svg>
                </a>
                <a href="https://www.linkedin.com/in/marcelkusar/" target="_blank" rel="noopener noreferrer" className="text-text-light hover:text-electric-blue transition-colors duration-300">
                  <Linkedin className="h-5 w-5" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-accent-blue/20 text-center text-text-light/60">
          <div className="flex flex-col items-center space-y-2">
            <p>&copy; {new Date().getFullYear()} New AI Systems. All rights reserved.</p>
            <div className="flex items-center space-x-4 text-sm">
              <Link to="/terms-of-service" className="text-text-light/60 hover:text-electric-blue transition-colors duration-300">
                Terms of Service
              </Link>
              <span className="text-text-light/40">•</span>
              <Link to="/privacy-policy" className="text-text-light/60 hover:text-electric-blue transition-colors duration-300">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;